<script>
// import { euroCouponsItemMethods } from '@state/helpers'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'EuroCouponsItemForm',
  components: {  },
  props: {
    // fullform: {
    //   type: Boolean,
    //   required: false,
    //   default: false,
    // },
    // instanceJson: {
    //   type: Object,
    //   required: false,
    //   default: () => ({}),
    // },
    // oncomplete: {
    //   type: Function,
    //   required: false,
    //   default: () => ({}),
    // },
    // oncancel: {
    //   type: Function,
    //   required: false,
    //   default: () => ({}),
    // },
    addItem: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      // modalShow: true,
      // loading: true,
      // submitting: false,
      // action: 'create',
      // euroCouponsItemOptions: [],
      form: {
        // url: null,
        // request: null,
        quantity: null,
        unit_value: null,
        // total: null,
      },
    }
  },
  validations: {
    form: {
      // request: { required, },
      quantity: { required, },
      unit_value: { required, },
      // total: { required, },
    },
  },
  computed: {},

  mounted: function () {
    // let context = this
    // context.form = {
    //   ...context.form, ...context.instanceJson,
    // }
    // if (context.instanceJson.url) {
    //   context.action = 'update'
    //   context.getObject()
    // } else {
    //   context.action = 'create'
    //   context.loading = false
    // }
  },

  methods: {
    // ...euroCouponsItemMethods,

    // getObject() {
    //   let context = this
    //   if (context.action == 'update') {
    //     const promise = context.fetchEuroCouponsItemDetail(context.form.url)
    //     return promise
    //       .then((data) => {
    //         context.form = { ...data }
    //         context.loading = false
    //       })
    //       .catch((error) => {
    //         context.$axios_error_noty(error, context)
    //         context.loading = false
    //       })
    //   }
    // },


    resetForm() {
        let context = this
        context.form.quantity = null
        context.form.unit_value = null
        context.$v.form.$reset()
      },

      add(event) {
        event.preventDefault()
        let context = this
        context.$v.form.$touch()
        if (context.$v.form.$invalid) {
          context.$generate_toast(
            context,
            'error',
            context.$t('fill_the_required_fields')
          )
      }else {
        context.addItem({...context.form})
        context.resetForm()

      }
    },



    // submit() {
    //   let context = this
    //   context.submitting = true
    //   context.$v.form.$touch()
    //   if (context.$v.form.$invalid) {
    //     context.submitting = false
    //     context.$generate_toast(
    //       context,
    //       'error',
    //       context.$t('fill_the_required_fields')
    //     )
    //     return
    //   }
    //   const promise = context.createUpdateEuroCouponsItem(context.form)
    //   return promise
    //     .then((data) => {
    //       context.$generate_toast(
    //         context,
    //         'success',
    //         `${context.$t('item')} ${
    //           context.action == 'create' ? context.$t('created') : context.$t('updated')
    //         } ${context.$t('correctly')}`
    //       )
    //       setTimeout(() => {
    //         context.oncomplete(data.url || null)
    //         context.submitting = false
    //       }, 2000)
    //     })
    //     .catch((error) => {
    //       context.submitting = false
    //       context.$axios_error_noty(error, context)
    //     })
    // },
  },
}
</script>

<template>
  <!-- <b-modal
    v-model="modalShow"
    :title="
      action === 'create' ? `${$t('create')} ${$t('item')}` : `${$t('update')} ${$t('item')}`
    "
    :size="action === 'create' ? 'lg' : 'lg'"
    @hidden="oncancel"
    @ok.prevent="submit"
  > -->
    <b-container class="p-0">
      <!-- <b-row v-if="loading">
        <b-col md="12">
          <div class="text-center">
            <b-spinner
              label="Spinning"
              style="color: #195db2; width: 4rem; height: 4rem"
            ></b-spinner>
          </div>
        </b-col>
      </b-row> -->
      <!-- v-else -->
      <b-row >
        <b-col md="12">
          <!-- 
            Don't touch this generic form, if you need a custom form do 
            a v-else instead and code an alternative form :) 
          -->
          <!-- v-if="fullform" -->
          <b-form  id="form" @submit="add"  @submit.stop.prevent>
            <form-wrapper :validator="$v.form">
              <p class="text-primary font-weight-bold">{{$t(`new_item`)}}</p>

                  <b-row>
                    <b-col  xs="12" md="6">
                      <!-- <form-group name="request" :label="$t(`request`)" >
                        <b-form-input
                          type="number"
                          v-model="form.request"
                          slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                        />
                      </form-group> -->
                      <!-- {{form}} -->
                      <form-group name="unit_value" :label="$t(`unit_value`)" :description="$t(`unit_value_help_text`)">
                        <b-form-input
                          type="number"
                          number
                          v-model="form.unit_value"
                          slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                        />
                      </form-group>
                    </b-col>
                      <b-col  xs="12" md="6">
                      <form-group name="quantity" label="Cantidad de Bonos" :description="$t(`quantity_help_text`)">
                        <b-form-input
                          type="number"
                          number
                          v-model="form.quantity"
                          slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                        />
                      </form-group>
                      <!-- <form-group name="total" :label="$t(`total`)" :description="$t(`total_help_text`)">
                        <b-form-input
                          type="number"
                          v-model="form.total"
                          slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                        />
                      </form-group> -->
                    </b-col>
                  </b-row>
              <div>
                <!-- <form-summary /> -->
              </div>
            </form-wrapper>
            <b-button type="submit" variant="primary" size="sm" class=" rounded-lg float-right"><i class="fas fa-plus"></i> {{$t(`add`)}}</b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-container>

    <!-- <template v-slot:modal-footer="{ ok, cancel }">
      <b-button size="sm" variant="secondary" @click="cancel">
        Cancelar
      </b-button>

      <b-button
        size="sm"
        variant="primary"
        :class="{ disabled: submitting }"
        @click="ok"
      >
        <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
        <span v-if="submitting"> {{ $t('saving') }} </span>
        <span v-else>
          <i class="fe-save"></i>
           {{ $t('save') }}
        </span>
      </b-button>
    </template> -->
  <!-- </b-modal> -->
</template>
<style lang="scss">
</style>